import axios from "axios";
import {API_ENDPOINTS} from "../../api/apiEndpoints";
import { apiRequest } from "@/network/apiClient";
import { useFetchExistingFiles } from "../../api/files/useFetchExistingFiles";
import React, { useState } from 'react';
import { toast } from "react-toastify";

const getAuthHeaders = () => {
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    return token ? { Authorization: `Bearer ${token}` } : {};
};

const ConfirmEmail = ({leadID, handleSendEmailConfirmationCancel, handleSendEmail}) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [showSelectedDocuments, setShowSelectedDocuments] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileKey, setFileKey] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [emailStatus, setEmailStatus] = useState(null); // 'success', 'error', or null
    const handleSelection = (fileId, content) => {
        setSelectedFiles(prevSelected => {
            if (prevSelected.includes(fileId)) {
                return prevSelected.filter(id => id !== fileId);
            } else {
                return [...prevSelected, fileId];
            }
        });
        setFileKey(prevKey => {
            if (prevKey.includes(content)) {
                return prevKey.filter(key => key !== content);
            } else {
                return [...prevKey, content];
            }
        });
    }
    const handleFileSelection = () =>{
        setShowSelectedDocuments(true);
    }
    const handleEmailCanclelation = () => {
        handleSendEmailConfirmationCancel(false);
    }

    const sendSelectedDocuments = async (e) => {
        setIsLoading(true);
        setEmailStatus(null);
        e.preventDefault();
        // Send to backend API
        try{
            
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_FILES.SEND_TO_COMPLIANCE}/${leadID}`, 'POST', fileKey)
            if(result){
                setEmailStatus('success');
                setTimeout(() => {
                    handleSendEmail();
                }, 2000);// Show success message for 2 seconds before closing
                toast.success('Email sent to compliance. Please check your email')
            } else {
                setEmailStatus('error');
            }
        }catch(error){
            toast.error(error || 'Error sending email');
            setEmailStatus('error');
        } finally {
            setIsLoading(false);
        }
    }

    const handleView = async (key) => {
        const authHeaders = getAuthHeaders();
        const res = await axios.get(`${import.meta.env.VITE_BASE_URL}/preview-file/${encodeURIComponent(key)}`,{
                    headers:{
                        ...authHeaders
                    }
                });
        window.open(res.data.url, '_blank', "noopener,noreferrer");
    };

    const {idFileCount,loaFileCount, othersFileCount,idFile,loaFile,othersFile} = useFetchExistingFiles(leadID, refreshTrigger);

    return(
        // Select Documents to be Submitted
        <>
        {/* {showSelectedDocuments && ( */}
            <div className="fixed inset-0 z-[70] bg-black bg-opacity-50 flex items-center justify-center text-center">
                <div className="bg-white p-6 rounded-lg w-auto scroll relative">
                    {isLoading && (
                        <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
                                <p className="text-lg font-semibold">Sending email...</p>
                                <p className="text-gray-600">Please wait while we process your request</p>
                            </div>
                        </div>
                    )}
                    
                    {emailStatus === 'success' && (
                        <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
                                    <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <p className="text-lg font-semibold text-green-600">Email sent successfully!</p>
                                <p className="text-gray-600">The documents have been sent to compliance</p>
                            </div>
                        </div>
                    )}
                    
                    {emailStatus === 'error' && (
                        <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </div>
                                <p className="text-lg font-semibold text-red-600">Failed to send email</p>
                                <p className="text-gray-600">Please try again or contact support</p>
                                <button
                                    className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                                    onClick={() => setEmailStatus(null)}
                                >
                                    Try Again
                                </button>
                            </div>
                        </div>
                    )}

                    <h2 className="text-lg font-bold mb-4">Send to Compliance</h2>
                    <h2 className="mb-4">Please make sure all the information are correct</h2>
                    <div className="mt-6 mb-6">
                        <button
                            className="text-black underline hover:text-blue-800 focus:outline-none"
                            onClick={handleEmailCanclelation}
                            disabled={isLoading}
                        >
                            <b>Cancel Submission</b>
                        </button>
                    </div>
                    <button
                        className={`bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400`}
                        onClick={sendSelectedDocuments}
                        disabled={ isLoading}
                    >
                        <b>{isLoading ? 'Sending...' : 'Send Email'}</b>
                    </button>
                </div>
                
            </div>
        {/* )} */}
        </>
    )
}

export default ConfirmEmail
